export default __webpack_public_path__ + "static/media/bluebird.20a9fd58.jpg";